import { Input } from "@bluecrew/blueprint-web";
import { SIZE } from "baseui/input";
import React from "react";
import { Column, StyledSettingText } from "../styledComponents";
import { ErrorMessage } from "../../GetCrewMembers/ErrorMessage";

type TimesheetsInputProps = {
  disabled: boolean;
  label: string;
  unit: string;
  value: number;
  onChange: (value: number) => void;
  error?: string;
};

export const TimesheetsInput = ({
  disabled,
  label,
  unit,
  value,
  onChange,
  error,
}: TimesheetsInputProps) => (
  <>
    <Column>
      <StyledSettingText>{label}</StyledSettingText>
      <div data-testid={label}>
        <div style={{ width: "140px", minHeight: "65px" }}>
          <Input
            disabled={disabled}
            size={SIZE.compact}
            type="number"
            value={value.toString() || ""}
            onChange={(val) => {
              const num = parseInt(val, 10);
              onChange(Number.isNaN(num) ? 0 : num);
            }}
            error={!!error}
            styles={{ textAlign: "end", width: "100%" }}
          />
          {error && (
            <div style={{ position: "absolute" }}>
              <ErrorMessage text={error} />
            </div>
          )}
        </div>
      </div>
    </Column>
    <div className="timesheets-unit">{unit}</div>
  </>
);
